module.exports = __webpack_public_path__ + "static/media/pp-PatientsPhone.92150545.png";